import * as React from "react";
import { observer } from "mobx-react";

import Alert from "../../alert/alert";
import { ContextMenuButton } from "../../context-menu/contextmenu";
import {
    Container,
    ImageWrapper,
    ProfileDropdown,
    Input,
    Image,
    Wrapper
} from "./profile-picture.styles";

export const DEFAULT_PROFILE_IMAGE = `https://static.grbydv.com/static/img/user-studio-default-profile-image.png`;

const ProfilePicture = observer(
    ({
        uploaderStore,
        profileUrl
    }: {
        uploaderStore: any; //TODO: needs typing
        profileUrl?: string;
    }) => {
        const hiddenFileInput = React.useRef(null);
        const dropdownRef = React.useRef(null);

        const currentUpload = uploaderStore.uploadsArray[0];
        const imageUrl =
            currentUpload?.storedURL || profileUrl || DEFAULT_PROFILE_IMAGE;

        const removeCurrentUpload = () => {
            uploaderStore.removeUpload(currentUpload.id);
        };

        const onChangeInput = ({
            target,
            target: { files }
        }: {
            target: { files: FileList; value: string };
        }) => {
            if (currentUpload) removeCurrentUpload();
            uploaderStore.uploadFile(files[0]);
            target.value = ``;
        };

        const dropdownOptions = [
            {
                id: `upload`,
                onClick: () => hiddenFileInput.current.click(),
                text: `Upload`
            },
            {
                id: `cloud upload`,
                onClick: uploaderStore.uploadFromFilestack,
                text: `Upload via cloud services`
            }
        ];

        const isLoading =
            currentUpload &&
            !(currentUpload.status === `valid`) &&
            !currentUpload.invalid;

        return (
            <Wrapper>
                <Container>
                    {isLoading ? (
                        <img
                            src="/static/img/loader.gif"
                            width="80"
                            height="80"
                        />
                    ) : (
                        <>
                            <ImageWrapper>
                                <Image src={imageUrl} width="80" height="80" />
                            </ImageWrapper>
                            <ProfileDropdown ref={dropdownRef}>
                                <ContextMenuButton
                                    isRound
                                    dropdownOptions={dropdownOptions}
                                    dataTestId="button-dropdown"
                                />
                                <Input
                                    ref={hiddenFileInput}
                                    type="file"
                                    name="upload-file"
                                    onChange={onChangeInput}
                                />
                            </ProfileDropdown>
                        </>
                    )}
                </Container>
                {currentUpload?.invalid && (
                    <Alert type={`error`}>
                        {currentUpload.errorMessages.map((message) => (
                            <span key={message}>
                                {message} <br></br>
                            </span>
                        ))}
                    </Alert>
                )}
            </Wrapper>
        );
    }
);

export default ProfilePicture;
